export const showToast = () => {
  if (navigator.userAgent.indexOf('Android') === -1) return;
  window.SysClientJs.getUserToken('getToken');
}

export const connectWebViewJavascriptBridge = (callback) => {

  //alert("call apple bridge functions");	
  if (window.WebViewJavascriptBridge) {
    // alert("window WebViewJavascriptBridge exists"); 
    callback(WebViewJavascriptBridge)
  } else {
    //alert("window WebViewJavascriptBridge not exists");   
    document.addEventListener('WebViewJavascriptBridgeReady', function () {
      //alert("WebViewJavascriptBridgeReady is happend");
      callback(WebViewJavascriptBridge)
    }, false)
  }
}




export const isSonyApp = () => {


  return /sonyapp/i.test(navigator.userAgent)

}

export const isApple = () => {

  return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);

}

export const isAndroid = () => {


  return /(Android)/i.test(navigator.userAgent);
}


export const doAppAction = (ed) => {

  try {

    if (isApple()) {
      //alert("apple to action"+JSON.stringify(ed));
      connectWebViewJavascriptBridge((bridge) => {
        bridge.send(JSON.stringify(ed), function (response) {
          console.log(response);
        })
      });
    }

    if (isAndroid() && ed.action) {

      window.SysClientJs[ed.action](JSON.stringify(ed));

    }

  } catch (err) {
    console.log("do app action", err);
  }


}










// WEBPACK FOOTER //
// ./src/commons/utils/bridge.js